// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1__UQ","cls2":"FilterPanel-cls2_BlD FilterPanel-cls1__UQ"};